import { motion } from 'framer-motion';

export default function QuickLinks() {
  const links = [
    {
      number: '01',
      title: 'ULAŞIM',
      icon: 'ri-map-pin-2-fill',
      image: '/transport-map.png',
      href: '/contact'
    },
    {
      number: '02',
      title: 'KAT PLANLARI',
      icon: 'ri-layout-grid-fill',
      image: '/fp-card.png',
      href: '/floor-plans'
    },
    {
      number: '03',
      title: 'E-KATALOG',
      icon: 'ri-file-pdf-2-fill',
      image: '/hero-avrupa.png',
      href: '/catalog'
    },
    {
      number: '04',
      title: 'TALEP FORMU',
      icon: 'ri-mail-check-fill',
      image: '/gallery-bulk-3.png',
      href: '/request-form'
    }
  ];

  return (
    <div className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-red-600 text-sm font-black tracking-[0.4em] uppercase block mb-4">KARE YAPI</span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tighter" style={{ fontFamily: 'Raleway, sans-serif' }}>
            ULAŞIM & FORM & KATALOG
          </h2>
        </motion.div>

        {/* Links Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {links.map((link, index) => (
            <motion.a
              key={index}
              href={link.href}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              whileHover={{ y: -12 }}
              className="relative group block"
            >
              <div className="relative h-[450px] rounded-[2.5rem] overflow-hidden shadow-[0_30px_60px_-15px_rgba(0,0,0,0.3)] hover:shadow-red-600/30 transition-all duration-500 border border-gray-100">
                {/* Background Image */}
                <img 
                  src={link.image} 
                  alt={link.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                />
                
                {/* Gradient Overlays */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute inset-0 bg-red-600/0 group-hover:bg-red-600/10 transition-colors duration-500" />

                {/* Content Overlay */}
                <div className="absolute inset-0 p-10 flex flex-col justify-between z-10">
                  <div className="flex justify-between items-start">
                    <span className="text-6xl font-black text-white/20 group-hover:text-red-600/50 transition-colors duration-500 leading-none">{link.number}</span>
                    <div className="w-14 h-14 bg-white/10 backdrop-blur-md rounded-2xl flex items-center justify-center group-hover:bg-red-600 transition-colors duration-500 border border-white/20">
                      <i className={`${link.icon} text-2xl text-white`} />
                    </div>
                  </div>

                  <div>
                    <h4 className="text-3xl font-black text-white mb-4 tracking-tight leading-tight" style={{ fontFamily: 'Raleway, sans-serif', textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
                      {link.title}
                    </h4>
                    <div className="w-12 h-1.5 bg-red-600 group-hover:w-full transition-all duration-500 rounded-full" />
                  </div>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  );
}